import createReducer from './createReducer';
import plain from './structure/plain';
export default createReducer(plain);


//////////////////
// WEBPACK FOOTER
// ../redux-form/es/reducer.js
// module id = 1379
// module chunks = 25